import {
  trackBrokerLoggedIn,
  trackBrokerRegistered,
  trackCreateEmptyLegOrder,
  trackOpenRegisterPageAfterVisitHome,
  trackOperatorLoggedIn,
  trackOperatorRegistered,
  trackOrderCreated,
  trackOrderRequestMakeOffer,
  trackPlaneCreated,
  trackRegistrationSuccess,
  trackRegisterFormRequestSent,
  trackRegisterFormTouched,
  trackSearchEmptyLegs,
  trackVisitAgentsPage
} from "../../../utils/analytics/ga";
import { amplitudeEvents } from "../../../utils/analytics/amplitude";

function dualTrack(gaFn: () => void, amplitudeFn: () => void) {
  gaFn();
  amplitudeFn();
}

export const metricsGoals = {
  visitAgentsPage: () => dualTrack(trackVisitAgentsPage, amplitudeEvents.visitAgentsPage),
  openRegisterPageAfterVisitHome: () => dualTrack(trackOpenRegisterPageAfterVisitHome, amplitudeEvents.openRegisterPageAfterVisitHome),
  registrationSuccess: () => dualTrack(trackRegistrationSuccess, amplitudeEvents.registrationSuccess),
  operatorRegistered: () => dualTrack(trackOperatorRegistered, amplitudeEvents.operatorRegistered),
  brokerRegistered: () => dualTrack(trackBrokerRegistered, amplitudeEvents.brokerRegistered),
  operatorLoggedIn: () => dualTrack(trackOperatorLoggedIn, amplitudeEvents.operatorLoggedIn),
  brokerLoggedIn: () => dualTrack(trackBrokerLoggedIn, amplitudeEvents.brokerLoggedIn),
  planeCreated: () => dualTrack(trackPlaneCreated, amplitudeEvents.planeCreated),
  registerFormTouched: () => dualTrack(trackRegisterFormTouched, amplitudeEvents.registerFormTouched),
  registerFormRequestSent: () => dualTrack(trackRegisterFormRequestSent, amplitudeEvents.registerFormRequestSent),
  orderRequestMakeOffer: () => dualTrack(trackOrderRequestMakeOffer, amplitudeEvents.orderRequestMakeOffer),
  orderCreated: () => dualTrack(trackOrderCreated, amplitudeEvents.orderCreated),
  searchEmptyLegs: () => dualTrack(trackSearchEmptyLegs, amplitudeEvents.searchEmptyLegs),
  createEmptyLegOrder: () => dualTrack(trackCreateEmptyLegOrder, amplitudeEvents.createEmptyLegOrder),
}